import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { UserIcon, SettingsIcon, LogOutIcon, HeartIcon, StarIcon, CalendarIcon, HomeIcon, MapPinIcon, CheckIcon, XIcon, EditIcon } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { mockUserBookings, mockUserFavorites } from '../utils/mockData';
const UserDashboardPage = () => {
  const [activeTab, setActiveTab] = useState('bookings');
  const {
    user,
    logout
  } = useAuth();
  const navigate = useNavigate();
  // Redirect to login if not authenticated
  if (!user) {
    navigate('/auth');
    return null;
  }
  const handleLogout = () => {
    logout();
    navigate('/');
  };
  const formatDate = dateString => {
    const options = {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };
  const renderTabContent = () => {
    switch (activeTab) {
      case 'bookings':
        return <div className="space-y-6" data-id="element-1191">
            <h2 className="text-xl font-semibold mb-4" data-id="element-1192">Your Bookings</h2>
            {mockUserBookings.length === 0 ? <div className="bg-white rounded-lg shadow-md p-6 text-center" data-id="element-1193">
                <div className="text-gray-500 mb-4" data-id="element-1194">
                  <CalendarIcon className="h-12 w-12 mx-auto mb-2 text-gray-400" data-id="element-1195" />
                  <p data-id="element-1196">You don't have any bookings yet.</p>
                </div>
                <Link to="/search" className="inline-block bg-[#006D77] hover:bg-[#00595f] text-white px-6 py-2 rounded-md font-medium" data-id="element-1197">
                  Find a Place to Stay
                </Link>
              </div> : <div className="grid grid-cols-1 gap-4" data-id="element-1198">
                {mockUserBookings.map(booking => <div key={booking.id} className="bg-white rounded-lg shadow-md overflow-hidden" data-id="element-1199">
                    <div className="flex flex-col md:flex-row" data-id="element-1200">
                      <div className="md:w-1/4" data-id="element-1201">
                        <img src={booking.property.images[0]} alt={booking.property.title} className="w-full h-48 md:h-full object-cover" data-id="element-1202" />
                      </div>
                      <div className="flex-1 p-4" data-id="element-1203">
                        <h3 className="font-semibold text-lg mb-1" data-id="element-1204">
                          {booking.property.title}
                        </h3>
                        <div className="flex items-center text-sm text-gray-600 mb-2" data-id="element-1205">
                          <MapPinIcon className="h-4 w-4 mr-1" data-id="element-1206" />
                          <span data-id="element-1207">{booking.property.location}</span>
                        </div>
                        <div className="flex flex-wrap gap-4 mb-3" data-id="element-1208">
                          <div className="flex items-center text-sm" data-id="element-1209">
                            <CalendarIcon className="h-4 w-4 mr-1 text-[#D4A017]" data-id="element-1210" />
                            <span data-id="element-1211">
                              {formatDate(booking.checkIn)} -{' '}
                              {formatDate(booking.checkOut)}
                            </span>
                          </div>
                          <div className="flex items-center text-sm" data-id="element-1212">
                            <UserIcon className="h-4 w-4 mr-1 text-[#D4A017]" data-id="element-1213" />
                            <span data-id="element-1214">{booking.guests} guests</span>
                          </div>
                        </div>
                        <div className="flex items-center text-sm font-medium" data-id="element-1215">
                          <span className="text-gray-600 mr-1" data-id="element-1216">Status:</span>
                          {booking.status === 'confirmed' && <span className="text-green-600 flex items-center" data-id="element-1217">
                              <CheckIcon className="h-4 w-4 mr-1" data-id="element-1218" /> Confirmed
                            </span>}
                          {booking.status === 'pending' && <span className="text-yellow-600" data-id="element-1219">Pending</span>}
                          {booking.status === 'cancelled' && <span className="text-red-600 flex items-center" data-id="element-1220">
                              <XIcon className="h-4 w-4 mr-1" data-id="element-1221" /> Cancelled
                            </span>}
                        </div>
                      </div>
                      <div className="p-4 border-t md:border-t-0 md:border-l border-gray-200 flex flex-col justify-between" data-id="element-1222">
                        <div data-id="element-1223">
                          <p className="text-lg font-bold" data-id="element-1224">
                            ${booking.totalPrice}
                          </p>
                          <p className="text-sm text-gray-500" data-id="element-1225">Total paid</p>
                        </div>
                        <div className="flex flex-col gap-2 mt-4" data-id="element-1226">
                          {booking.status !== 'cancelled' && <button className="bg-white border border-red-500 text-red-500 hover:bg-red-50 px-4 py-2 rounded-md text-sm font-medium" data-id="element-1227">
                              Cancel Booking
                            </button>}
                          <Link to={`/property/${booking.property.id}`} className="bg-[#006D77] hover:bg-[#00595f] text-white px-4 py-2 rounded-md text-sm font-medium text-center" data-id="element-1228">
                            View Property
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>)}
              </div>}
          </div>;
      case 'favorites':
        return <div className="space-y-6" data-id="element-1229">
            <h2 className="text-xl font-semibold mb-4" data-id="element-1230">Your Favorites</h2>
            {mockUserFavorites.length === 0 ? <div className="bg-white rounded-lg shadow-md p-6 text-center" data-id="element-1231">
                <div className="text-gray-500 mb-4" data-id="element-1232">
                  <HeartIcon className="h-12 w-12 mx-auto mb-2 text-gray-400" data-id="element-1233" />
                  <p data-id="element-1234">You don't have any favorites yet.</p>
                </div>
                <Link to="/search" className="inline-block bg-[#006D77] hover:bg-[#00595f] text-white px-6 py-2 rounded-md font-medium" data-id="element-1235">
                  Explore Properties
                </Link>
              </div> : <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-1236">
                {mockUserFavorites.map(property => <Link key={property.id} to={`/property/${property.id}`} className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow" data-id="element-1237">
                    <div className="relative h-48" data-id="element-1238">
                      <img src={property.images[0]} alt={property.title} className="w-full h-full object-cover" data-id="element-1239" />
                      <button className="absolute top-3 right-3 bg-white rounded-full p-1.5 shadow-md" data-id="element-1240">
                        <HeartIcon className="h-5 w-5 text-[#FF6B6B] fill-[#FF6B6B]" data-id="element-1241" />
                      </button>
                    </div>
                    <div className="p-4" data-id="element-1242">
                      <div className="flex justify-between items-start" data-id="element-1243">
                        <h3 className="font-semibold text-lg text-[#333333] line-clamp-1" data-id="element-1244">
                          {property.title}
                        </h3>
                        <div className="flex items-center" data-id="element-1245">
                          <StarIcon className="h-4 w-4 text-[#D4A017] fill-[#D4A017]" data-id="element-1246" />
                          <span className="ml-1 text-sm font-medium" data-id="element-1247">
                            {property.rating}
                          </span>
                        </div>
                      </div>
                      <div className="flex items-center mt-2 text-sm text-gray-500" data-id="element-1248">
                        <MapPinIcon className="h-4 w-4 mr-1" data-id="element-1249" />
                        <span className="line-clamp-1" data-id="element-1250">
                          {property.location}
                        </span>
                      </div>
                      <div className="mt-4" data-id="element-1251">
                        <span className="font-bold text-[#333333]" data-id="element-1252">
                          ${property.pricePerNight}
                        </span>
                        <span className="text-gray-500 text-sm" data-id="element-1253"> / night</span>
                      </div>
                    </div>
                  </Link>)}
              </div>}
          </div>;
      case 'profile':
        return <div className="space-y-6" data-id="element-1254">
            <h2 className="text-xl font-semibold mb-4" data-id="element-1255">Your Profile</h2>
            <div className="bg-white rounded-lg shadow-md p-6" data-id="element-1256">
              <div className="flex items-center mb-6" data-id="element-1257">
                <div className="bg-[#006D77] rounded-full w-16 h-16 flex items-center justify-center text-white text-2xl font-semibold" data-id="element-1258">
                  {user.name.charAt(0)}
                </div>
                <div className="ml-4" data-id="element-1259">
                  <h3 className="font-semibold text-lg" data-id="element-1260">{user.name}</h3>
                  <p className="text-gray-600" data-id="element-1261">{user.email}</p>
                </div>
                <button className="ml-auto bg-white border border-gray-300 text-gray-700 hover:bg-gray-50 p-2 rounded-md" data-id="element-1262">
                  <EditIcon className="h-5 w-5" data-id="element-1263" />
                </button>
              </div>
              <div className="space-y-4" data-id="element-1264">
                <div data-id="element-1265">
                  <h4 className="text-sm font-medium text-gray-500 mb-1" data-id="element-1266">
                    Full Name
                  </h4>
                  <p data-id="element-1267">{user.name}</p>
                </div>
                <div data-id="element-1268">
                  <h4 className="text-sm font-medium text-gray-500 mb-1" data-id="element-1269">
                    Email
                  </h4>
                  <p data-id="element-1270">{user.email}</p>
                </div>
                <div data-id="element-1271">
                  <h4 className="text-sm font-medium text-gray-500 mb-1" data-id="element-1272">
                    Phone
                  </h4>
                  <p data-id="element-1273">{user.phone || 'Not provided'}</p>
                </div>
                <div data-id="element-1274">
                  <h4 className="text-sm font-medium text-gray-500 mb-1" data-id="element-1275">
                    Member Since
                  </h4>
                  <p data-id="element-1276">{user.memberSince || 'January 2023'}</p>
                </div>
              </div>
              <div className="mt-6 pt-6 border-t border-gray-200" data-id="element-1277">
                <button className="bg-[#006D77] hover:bg-[#00595f] text-white px-4 py-2 rounded-md text-sm font-medium" data-id="element-1278">
                  Edit Profile
                </button>
              </div>
            </div>
            <div className="bg-white rounded-lg shadow-md p-6" data-id="element-1279">
              <h3 className="font-semibold text-lg mb-4" data-id="element-1280">Account Settings</h3>
              <div className="space-y-4" data-id="element-1281">
                <div className="flex items-center justify-between" data-id="element-1282">
                  <div data-id="element-1283">
                    <h4 className="font-medium" data-id="element-1284">Change Password</h4>
                    <p className="text-sm text-gray-500" data-id="element-1285">
                      Update your password
                    </p>
                  </div>
                  <button className="text-[#006D77] hover:underline" data-id="element-1286">
                    Change
                  </button>
                </div>
                <div className="flex items-center justify-between" data-id="element-1287">
                  <div data-id="element-1288">
                    <h4 className="font-medium" data-id="element-1289">Notification Preferences</h4>
                    <p className="text-sm text-gray-500" data-id="element-1290">
                      Manage email notifications
                    </p>
                  </div>
                  <button className="text-[#006D77] hover:underline" data-id="element-1291">
                    Manage
                  </button>
                </div>
                <div className="flex items-center justify-between" data-id="element-1292">
                  <div data-id="element-1293">
                    <h4 className="font-medium" data-id="element-1294">Payment Methods</h4>
                    <p className="text-sm text-gray-500" data-id="element-1295">
                      Add or remove payment methods
                    </p>
                  </div>
                  <button className="text-[#006D77] hover:underline" data-id="element-1296">
                    Manage
                  </button>
                </div>
                <div className="flex items-center justify-between" data-id="element-1297">
                  <div data-id="element-1298">
                    <h4 className="font-medium text-red-600" data-id="element-1299">Delete Account</h4>
                    <p className="text-sm text-gray-500" data-id="element-1300">
                      Permanently delete your account
                    </p>
                  </div>
                  <button className="text-red-600 hover:underline" data-id="element-1301">
                    Delete
                  </button>
                </div>
              </div>
            </div>
          </div>;
      default:
        return null;
    }
  };
  return <div className="bg-[#F8F5F0] min-h-screen w-full py-8" data-id="element-1302">
      <div className="container mx-auto px-4" data-id="element-1303">
        <h1 className="text-2xl md:text-3xl font-bold text-[#333333] mb-6" data-id="element-1304">
          Your Dashboard
        </h1>
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6" data-id="element-1305">
          {/* Sidebar */}
          <div className="md:col-span-1" data-id="element-1306">
            <div className="bg-white rounded-lg shadow-md p-4 sticky top-24" data-id="element-1307">
              <div className="flex items-center p-2 mb-4" data-id="element-1308">
                <div className="bg-[#006D77] rounded-full w-10 h-10 flex items-center justify-center text-white font-semibold" data-id="element-1309">
                  {user.name.charAt(0)}
                </div>
                <div className="ml-3" data-id="element-1310">
                  <p className="font-medium" data-id="element-1311">{user.name}</p>
                  <p className="text-sm text-gray-500" data-id="element-1312">Guest</p>
                </div>
              </div>
              <nav className="space-y-1" data-id="element-1313">
                <button className={`flex items-center w-full p-3 rounded-md ${activeTab === 'bookings' ? 'bg-[#006D77] text-white' : 'hover:bg-gray-100 text-gray-700'}`} onClick={() => setActiveTab('bookings')} data-id="element-1314">
                  <CalendarIcon className="h-5 w-5 mr-3" data-id="element-1315" />
                  <span data-id="element-1316">Your Bookings</span>
                </button>
                <button className={`flex items-center w-full p-3 rounded-md ${activeTab === 'favorites' ? 'bg-[#006D77] text-white' : 'hover:bg-gray-100 text-gray-700'}`} onClick={() => setActiveTab('favorites')} data-id="element-1317">
                  <HeartIcon className="h-5 w-5 mr-3" data-id="element-1318" />
                  <span data-id="element-1319">Favorites</span>
                </button>
                <button className={`flex items-center w-full p-3 rounded-md ${activeTab === 'profile' ? 'bg-[#006D77] text-white' : 'hover:bg-gray-100 text-gray-700'}`} onClick={() => setActiveTab('profile')} data-id="element-1320">
                  <UserIcon className="h-5 w-5 mr-3" data-id="element-1321" />
                  <span data-id="element-1322">Profile</span>
                </button>
                <button className={`flex items-center w-full p-3 rounded-md ${activeTab === 'settings' ? 'bg-[#006D77] text-white' : 'hover:bg-gray-100 text-gray-700'}`} onClick={() => setActiveTab('profile')} // Direct to profile for now
              data-id="element-1323">
                  <SettingsIcon className="h-5 w-5 mr-3" data-id="element-1324" />
                  <span data-id="element-1325">Settings</span>
                </button>
                <button className="flex items-center w-full p-3 rounded-md text-red-600 hover:bg-red-50" onClick={handleLogout} data-id="element-1326">
                  <LogOutIcon className="h-5 w-5 mr-3" data-id="element-1327" />
                  <span data-id="element-1328">Logout</span>
                </button>
              </nav>
            </div>
          </div>
          {/* Main Content */}
          <div className="md:col-span-3" data-id="element-1329">{renderTabContent()}</div>
        </div>
      </div>
    </div>;
};
export default UserDashboardPage;